export const IncomingCallDefaultValues = {
  reporter: {
    callerPhoneNumber: '',
  },
};

export enum IncomingCallEvent {
  CREATED = 'CREATED',
  ANSWERED = 'ANSWERED',
  COMPLETED = 'COMPLETED',
  MISSED = 'MISSED',
  READ = 'READ',
  MODIFIED = 'MODIFIED',
}
